export default __webpack_public_path__ + "static/frame-2-4c12f75f98a5cced90e194306adecaf4.png";